import { render, staticRenderFns } from "./proReviewDx.vue?vue&type=template&id=0f80d184&scoped=true&"
import script from "./proReviewDx.vue?vue&type=script&lang=js&"
export * from "./proReviewDx.vue?vue&type=script&lang=js&"
import style0 from "./proReviewDx.vue?vue&type=style&index=0&id=0f80d184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f80d184",
  null
  
)

export default component.exports